<template>
  <a-modal
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :title="'兑换'"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item label="购买商品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['product_type',{rules: [{ required: true}]}]" placeholder="请选择">
            <a-select-option
              :value="item.id"
              v-for="(item,index) in list"
              :key="index"
            >{{item.productDes}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="购买数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            :style="{width:'100%'}"
            :min="1"
            v-decorator="['product_number', {initialValue:1,rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
          />
        </a-form-item>
        <a-form-item
          label="实际支付"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >{{payment/100 | currency('') }}NB</a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import PropertyCardApi from '@/api/property-card'
import ConductApi from '@/api/conduct'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          setTimeout(() => {
            this.initPayment()
          }, 500)
        }
      }),
      payment: 0,
      list: []
    }
  },
  computed: {},
  created() {},
  methods: {
    show() {
      this.form.resetFields()
      this.payment = 0
      this.visible = true
      this.getData()
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          PropertyCardApi.exchangeCardByNb({ 
            product_type: values.product_type, 
            product_number: values.product_number 
          })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('兑换成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    getData() {
      this.pullLoading = true
      ConductApi.getProductList()
        .then(res => {
          if (res.code === 1) {
            this.list = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    initPayment() {
      const product_number = this.form.getFieldValue('product_number')
      const product_type = this.form.getFieldValue('product_type')
      const product = this.list.find(item => {
        return item.id == product_type
      })
      if (!product) return false
      const product_price = product.productPrice
      this.payment = product_number * product_price
    }
  }
}
</script>
<style lang="less">
</style>
